module.exports = __webpack_public_path__ + "images/bg-app.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/bg-app.png
// module id = 807
// module chunks = 106